import { get } from './P3Api';

class CategoryGroupCommoditySubcommidityApi {
  static async getCategoryGroupCommoditySubcommodities(categoryId, groupId, commodityId) {
    return get(`categories/${categoryId}/groups/${groupId}/commodities/${commodityId}/subcommodities`);
  }
}

export default CategoryGroupCommoditySubcommidityApi;
